import { unhandledRequest } from 'api/request';

import { MyTimePlanSettingsResponse, MyTimePlanSaveSettingsResponse } from './types';

export async function myTimePlanGetSettings() {
  const response = await unhandledRequest.get<MyTimePlanSettingsResponse>({
    url: `/integrations/mytimeplan/settings/`,
  });
  return response.data;
}

export async function myTimePlanSaveSettings(url: string, username: string, password: string) {
  const response = await unhandledRequest.patch<MyTimePlanSaveSettingsResponse>({
    url: `/integrations/mytimeplan/settings/`,
    data: { url, username, password },
  });
  return response.data;
}
